module.exports = __webpack_public_path__ + "assets/7e0522585bc7ff65d7b55f6cbc28c359.png";